// import external dependencies
import 'jquery';

// Require/Import vendors
require('../../../node_modules/flickity/dist/flickity.pkgd')
require('../../../node_modules/overlayscrollbars/js/jquery.overlayScrollbars');
require('./vendor/flickity-fullscreen');
require('./vendor/jquery.txtTruncate');

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies/utils
import Router from './util/Router';
import common from './routes/common';
import { sliders } from './components/sliders';
import LazyLoad from 'vanilla-lazyload';
import { stokpress } from './util/helper';

window.stokpress = stokpress;

require('./util/plusItem');
require('./util/crossPlatform');
require('./util/autoPadding');
require('./util/ellipsis');
require('./util/backgroundSwitcher');
require('./util/articleFilter');
require('./util/checkTouch');
require('./util/displayProp');
require('./util/disableBodyScroll');

// Require Components
// components are now on common. See routes below
// routes will be found on routes folder

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

// Load Events
document.addEventListener('DOMContentLoaded', () => {
  routes.loadEvents();
	sliders.init();

  $('body').autoPadding({
    source: $('.js-header'),
  });

  let lazyLoadInstance = new LazyLoad({
    threshold: 500,
    elements_selector: '.lazy',
  });

  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  }

	window.lazyLoadInstance = lazyLoadInstance;
});


// WEBPACK FOOTER //
// ./scripts/main.js